import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const QA = [
  ["What is UrgentSellBuy?", "A marketplace for things that need to sell soon, and for buyers who like to move quickly on a good deal."],
  ["Is there a mobile app?", "Yes, UrgentSellBuy has a mobile app. Store links will appear here: [App Store link] and [Google Play link]."],
  ["When does the web marketplace open?", "[Launch date or timeline]. Join the early access list and we'll email you the moment it's live."],
  ["How much does it cost to list?", "[Add your listing fees or say it's free.]"],
  ["How do I stay safe when buying or selling?", "[Add your safety guidance, e.g. meet in public places and use in-app messaging.]"],
];

export const Faq = () => (
  <section id="faq" className="mx-auto max-w-7xl px-5 sm:px-8 pb-24 lg:pb-36 grid lg:grid-cols-12 gap-10" data-testid="faq-section">
    <Reveal className="lg:col-span-4">
      <Eyebrow>FAQ</Eyebrow>
      <h2 className="mt-6 font-display text-3xl sm:text-4xl font-bold tracking-tight">Quick answers.</h2>
    </Reveal>
    <Reveal className="lg:col-span-8" delay={0.1}>
      <Accordion type="single" collapsible className="border-t border-white/10">
        {QA.map(([q, a], i) => (
          <AccordionItem key={q} value={`q${i}`} className="border-white/10">
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="py-6 text-left font-display text-lg sm:text-xl font-medium hover:no-underline hover:text-[#FF3838] transition-colors">
              {q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-base text-zinc-400 leading-relaxed">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
